import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-153">
          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-154">
            Est-ce que tu te reconnais dans ce silence pesant ? Ce moment, vers
            21h, où les enfants dorment (ou sont chez leur père), et où tu te
            retrouves seule face à ton reflet dans le miroir... en te demandant
            :
          </p>

          <blockquote className="font-playfair italic text-2xl md:text-3xl text-burgundy text-center py-4 border-l-4 border-gold pl-6 my-4" data-id="element-155">
            "Mais où est passée la femme pétillante que j'étais avant tout ça ?"
          </blockquote>
        </motion.div>
      </div>
    </section>;
}